export default {
  HEADER_ITEM_TITLE_HOME: "Home",
  HEADER_ITEM_TITLE_ABOUT: "About",
  HEADER_ITEM_TITLE_CASES: "Cases",
  HEADER_ITEM_TITLE_CONTACT: "Contact",
  HEADER_ITEM_TITLE_CV: "Access CV",

  BANNER_TITLE: "Wilton Junior",
  BANNER_SUB_TITLE: "Full Stack Developer",
  BANNER_SUB_PARAGRAPH_ONE: `Full-stack programmer, passionate about software development, graduated in <strong> Computer scientist </strong>, by the <strong> State University of Rio Grande do Norte - UERN </strong>, working since 2016 in development
  of web and mobile systems. </br> </br> Using the most diverse technologies of modernity, with applicability in the construction of hybrid, responsive and cross browser applications. Currently acting as a project leader.`,
  BANNER_BUTTON_PORTFOLIO: "Portfolio",
  BANNER_BUTTON_CONTACT: "Contact",

  ABOUT_DESCRIPTION: `Programmer and developer for over <strong> 5 years </strong> working directly in the market.
  I started my career at the university, working on teaching and extension research projects,
  that's when I realized what I was really born to do: <strong> code </strong>, I love building templates from scratch, without the
  need to use any css framework, the bigger the challenge, the better!
  </br> </br>
  My first job was at a <strong> multinational </strong>, which provided me with incredible experiences that made me grow even more as a professional,
  from there, external projects began in the most diverse ways, websites, applications, systems, which made me acquire a vast
  knowledge in the various programming languages ​​used today by the market.
  </br> </br>
  I keep investing more and more in my career as a developer, studying and passing on a little of my experience to my colleagues in the area, always in contact with the community. To this end, we created a platform for developers to share their experiences, which we call <a href="https://share.dev.br/"> Dev Share </a>
  aiming to reach the largest number of developers with articles from the most diverse areas of technology.`,
  ABOUT_CARD_TITLE_ONE: "Academy",
  ABOUT_CARD_DESCRIPTION_ONE:
    "Graduated in Computer Science at the State University of Rio Grande do Norte - UERN.",
  ABOUT_CARD_TITLE_TWO: "Experiencia",
  ABOUT_CARD_DESCRIPTION_TWO:
    "I have been working since 2016 with front end, back end and mobile development. Especially with the java script stack, like Reactjs, Angular.io, Vuejs and Nodejs.",

  ABOUT_SECTION_SHADOW: "About",
  ABOUT_SECTION_TITLE: "About me",
  ABOUT_SECTION_DESCRIPTION: "Know a little about my story.",

  ACESS_CASE: "Access Case",

  CONTACT_TITLE: "Contact",
  CONTACT_DESCRITPION:
    "If you want to get in touch, fill out the form below. I will get in touch with you soon.",
  CONTACT_INPUT_LABEL_NAME: "Name",
  CONTACT_INPUT_LABEL_EMAIL: "Email",
  CONTACT_INPUT_LABEL_MESSAGE: "Message",
  CONTACT_FORM_SEND: "Submit",
  CONTACT_INPUT_PLACEHOLDER_NAME: "Name",
  CONTACT_INPUT_PLACEHOLDER_EMAIL: "Email",
  CONTACT_INPUT_PLACEHOLDER_MESSAGE: "Message",

  CONTACT_WHATSAPP: "Whatsapp",
  CONTACT_INSTAGRAM: "Instagram",
  CONTACT_EMAIL: "Email",
  CONTACT_LINKEDIN: "Linkedin",
  CONTACT_GIT: "Git Hub",

  FOOTER_TITLE: "© Copyright 2020 WiltonJunior. All Rights Reserved",

  CASE_TITLE: "Cases",
  CASE_SHODOW: "Portfolio",
  CASE_DESCRIPTION: "Browse my jobs.",

  CASE_ONE_TITLE: "More Miles",
  CASE_ONE_DESCRIPTION: "A platform for the purchase and sale of airline miles",
  CASE_ONE_ARTICLE_ONE_TITLE:
    "MaisMilhas has as its object the purchase and sale of airline miles, the application was built using a series of technologies among which, Nextjs stands out for increasing the performance performance of the application, the back-end was built using Nodejs with mongoDB ",

  CASE_TWO_TITLE: "Zabbix Report",
  CASE_TWO_DESCRIPTION: "Lady page for disclosure and presentation of the company",
  CASE_TWO_ARTICLE_ONE_TITLE:
    "Cross browser multiplatform application, responsible for promoting and presenting the product. The front-end was built using React and the back-end in Nodejs with sequelize",

  CASE_THREE_TITLE: "Easy Institute",
  CASE_THREE_DESCRIPTION: "Lady page for publicizing and presenting the company",
  CASE_THREE_ARTICLE_ONE_TITLE:
    "Cross-browser multiplatform application, responsible for publicizing and presenting the school and its units, consisting of an administrative area for controlling the branches. The front end was built using Angular.io and the back end in Nodejs with arangoDB",
}